/* istanbul ignore file */
/* eslint-disable dot-notation */
import { StrictMode } from 'react';
import ReactDOM from 'react-dom';
import '@betrybe/ada-react/dist/styles.css';
import './tailwind.output.css';
import * as Sentry from '@sentry/react';
import { Integrations } from '@sentry/tracing';
import { FliptProvider as FliptContextProvider } from '@betrybe/flipt-react';

import App from './App';
import { beforeSendSentryError } from './utils';

Sentry.init({
  // eslint-disable-next-line dot-notation
  dsn: process.env.REACT_APP_SENTRY_DSN,
  environment: process.env.REACT_APP_ENVIRONMENT,
  integrations: [new Integrations.BrowserTracing()],
  tracesSampleRate: 0.25,

  ignoreErrors: [
    'ChunkLoadError',
    'Request aborted',
    "expected expression, got '<'",
    "Unexpected token '<'",
    'CodeMirror',
    'fail with status code 404',
    'fail with status code 401',
    'Large Render Blocking Asset',
    'Non-Error exception captured with keys: errors, type',
  ],
  normalizeDepth: 10,
  beforeSend: beforeSendSentryError,
});

ReactDOM.render(
  <StrictMode>
    <FliptContextProvider uri={process.env['REACT_APP_FLIPT_URL'] || ''}>
      <App />
    </FliptContextProvider>
  </StrictMode>,
  document.getElementById('root'),
);
